import { render, staticRenderFns } from "./corp-report.vue?vue&type=template&id=1b07fa6c&scoped=true&"
import script from "./corp-report.vue?vue&type=script&lang=js&"
export * from "./corp-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b07fa6c",
  null
  
)

export default component.exports